    import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";

import { SharedModule } from './Shared/shared.module';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { ReceiptModule } from './receipt/receipt.module';
import { DataTableModule } from 'angular-6-datatable-cc/lib/src/DataTableModule';
import { DataTable } from 'angular-6-datatable-cc/src/DataTable';
// import { HttpsInterceptor } from 'src/https-interceptor';
// import { HttpsInterceptor } from 'src/https-interceptor';

// Import HTTPS Interceptor
// import { HttpsInterceptor } from './././';


@NgModule({
    declarations: [
        AppComponent, 
        // DataTable
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        AppRoutingModule,
        SharedModule,
        ReceiptModule,
        DataTableModule
    ],
    providers: [
        // { provide: HTTP_INTERCEPTORS, useClass: HttpsInterceptor, multi: true } // Register HTTPS Interceptor
      ],
      bootstrap: [AppComponent]
})

export class AppModule { }
